import { Step } from 'signup-constants/Step';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getHttpResponse } from '../../store/http-responses/selectors';
import { EndpointKey } from '../../http/EndpointKey';
import { getIsNewUser } from '../../store/app/selectors';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
export const getShouldAddHubletSelection = state => {
  const httpResponse = getHttpResponse(state, EndpointKey.HubletChoiceNewUser);
  return getIsNewUser(state) && httpResponse && httpResponse.availableHublets && httpResponse.availableHublets.length > 1;
};
export const BranchAddHubletNewUser = {
  name: 'BranchAddHubletNewUser',
  stateCheck: state => {
    const isAssignedToACQ173VariantAorC = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0173, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_C]);
    if (isAssignedToACQ173VariantAorC) {
      return false;
    }
    const shouldAddHubletSelection = getShouldAddHubletSelection(state);
    return shouldAddHubletSelection;
  },
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.addLastStepsBeforeAccountCreation(Step.HubletSelection));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};